<div class="flex">
  <app-strategy-advanced-settings
    class="w-full"
    [strategy]="modalData.strategy"
    [strategyGroup]="undefined"
    [advancedSettings]="advancedSettings()"
  />
</div>
